module.exports = require("core-js/library/fn/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/object/get-own-property-symbols.js
// module id = 90
// module chunks = 0 1